module.exports = __webpack_public_path__ + "img/logo.ed71a00b.jpg";